import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../services/api';
import { projectKeys } from './useProjects';
import type {
  Preventivo,
  CreatePreventivoInput,
  UpdatePreventivoInput,
} from '../types';

export function useCreatePreventivo() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreatePreventivoInput) =>
      api.post<Preventivo>('/preventivi', data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: projectKeys.detail(variables.projectId),
      });
    },
  });
}

export function useUpdatePreventivo() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables: {
      id: string;
      projectId: string;
      data: UpdatePreventivoInput;
    }) => api.patch<Preventivo>(`/preventivi/${variables.id}`, variables.data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: projectKeys.detail(variables.projectId),
      });
    },
  });
}

export function useDeletePreventivo() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id }: { id: string; projectId: string }) =>
      api.delete(`/preventivi/${id}`),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: projectKeys.detail(variables.projectId),
      });
    },
  });
}
